// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard{min-height:550px}.dashboard .text-highlight{color:#e3e3e3}.dashboard h2,.dashboard h3,.dashboard h4,.dashboard h5,.dashboard h6{font-weight:400;padding:0;margin-bottom:16px}.dashboard h4,.dashboard h5{color:#b3abd6}.dashboard h6{color:#a2a2a2}.dashboard p{color:#c9c9dd}.dashboard-enter-active,.dashboard-leave-active{transition-property:opacity;transition-timing-function:ease-in-out;transition-duration:.1s}.dashboard-enter,.dashboard-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
